import { Label } from "@mui/icons-material";
import React, { FunctionComponent, useState } from "react";
import SelectorDialogBase from "../base/SelectorDialogBase";
import Chip from "./Chip";

const ListTypes = ["Incident", "Task"];

interface Props {
	type?: string,
	onChange: (type: string) => void,
	sx?: any
}

const SelectorTypeH: FunctionComponent<Props> = ({
	type,
	onChange,
	sx,
}) => {

	// HOOKs
	const [isOpen, setIsOpen] = useState(false)

	// HANDLER
	const handleClick = () => {
		setIsOpen(true)
	}
	const handleClose = (newType: string) => {
		setIsOpen(false)
		if (newType) onChange?.(newType)
	}
	const handleClear = (e: React.MouseEvent) => {
		e.stopPropagation()
		setIsOpen(false)
		onChange?.(null)
	}

	// RENDER
	const isActive = !!type

	return (<>
		<Chip sx={sx}
			label={type?.toUpperCase() ?? "ALL TYPES"}
			icon={ <Label sx={{ width: 18, height: 18 }} />}
			tooltip={"VIEW ONLY THIS TYPE"}
			active={isActive}
			onClick={handleClick}
			onClear={handleClear}
		/>
		<SelectorDialogBase
			width="auto"
			height={null}
			icon={<Label />}
			items={ListTypes}
			idSelect={type}
			title={"SELECT A TYPE"}
			isOpen={isOpen}
			onClose={handleClose}
			onClear={handleClear}
			fnTextFromItem={item => item.toUpperCase()}
			fnIdFromItem={item => item}
		/>
	</>)
}

export default SelectorTypeH
